// import "./pagination.css";
// const RANGE = 2;

// const Pagination = ({ page: pageState, pageSize, limit, handleChangePage }) => {
//   const page = Number(pageState);
//   pageSize = Math.ceil(pageSize / limit);

//   const renderPagination = () => {
//     let dotAfter = false;
//     let dotBefore = false;
//     const renderDotBefore = (index) => {
//       if (!dotBefore) {
//         dotBefore = true;
//         return (
//           <span key={index} className="pagination-dot">
//             ...
//           </span>
//         );
//       }
//       return null;
//     };

//     const renderDotAfter = (index) => {
//       if (!dotAfter) {
//         dotAfter = true;
//         return (
//           <span key={index} className="pagination-dot">
//             ...
//           </span>
//         );
//       }
//       return null;
//     };

//     return Array(pageSize)
//       .fill(0)
//       .map((_, index) => {
//         const pageNumber = index + 1;

//         if (
//           page <= RANGE * 2 + 1 &&
//           pageNumber > page + RANGE &&
//           pageNumber < pageSize - RANGE + 1
//         ) {
//           return renderDotAfter(index);
//         } else if (page > RANGE * 2 + 1 && page < pageSize - RANGE * 2) {
//           if (pageNumber > RANGE && pageNumber < page - RANGE) {
//             return renderDotBefore(index);
//           } else if (
//             pageNumber > page + RANGE &&
//             pageNumber < pageSize - RANGE + 1
//           ) {
//             return renderDotAfter(index);
//           }
//         } else if (
//           page >= pageSize - RANGE * 2 &&
//           pageNumber > RANGE &&
//           pageNumber < page - RANGE
//         ) {
//           return renderDotBefore(index);
//         }

//         return (
//           <div
//             key={index}
//             className={`pagination-page ${
//               pageNumber === page
//                 ? "pagination-page-active"
//                 : "pagination-page-inactive"
//             }`}
//             onClick={() => handleChangePage(pageNumber)}
//           >
//             {pageNumber}
//           </div>
//         );
//       });
//   };

//   return (
//     <div className="pagination">
//       {!pageSize || page === 1 ? (
//         <span className="pagination-next-prev-disable">Prev</span>
//       ) : (
//         <div
//           className="pagination-next-prev"
//           onClick={() => handleChangePage(page - 1)}
//         >
//           Prev
//         </div>
//       )}

//       {renderPagination()}

//       {!pageSize || page === pageSize ? (
//         <span className="pagination-next-prev-disable">Next</span>
//       ) : (
//         <div
//           className="pagination-next-prev"
//           onClick={() => handleChangePage(page + 1)}
//         >
//           Next
//         </div>
//       )}
//     </div>
//   );
// };

// export default Pagination;

import React from "react";
import {
  Pagination as MuiPagination,
  PaginationItem,
  Stack,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const RANGE = 2;

const StyledPagination = styled(MuiPagination)(({ theme }) => ({
  "& .MuiPaginationItem-root": {
    margin: theme.spacing(0, 0.5),
  },
}));

const Pagination = ({ page: pageState, pageSize, limit, handleChangePage }) => {
  const page = Number(pageState);
  const totalPages = Math.ceil(pageSize / limit);

  const handleChange = (event, value) => {
    handleChangePage(value);
  };

  const renderItem = (item) => {
    if (item.type === "page") {
      const pageNumber = item.page;
      const isVisible = shouldShowPage(pageNumber);

      if (!isVisible && (pageNumber === 2 || pageNumber === totalPages - 1)) {
        return <PaginationItem {...item} type="ellipsis" />;
      }

      return isVisible ? <PaginationItem {...item} /> : null;
    }

    return <PaginationItem {...item} />;
  };

  const shouldShowPage = (pageNumber) => {
    if (pageNumber === 1 || pageNumber === totalPages) return true;
    if (page <= RANGE * 2 + 1) return pageNumber <= RANGE * 2 + 3;
    if (page >= totalPages - RANGE * 2)
      return pageNumber >= totalPages - RANGE * 2 - 2;
    return Math.abs(pageNumber - page) <= RANGE;
  };

  return (
    <Box display="flex" justifyContent="flex-end" width="100%" mt={2}>
      <Stack spacing={2} direction="row" alignItems="center">
        <StyledPagination
          count={totalPages}
          page={page}
          onChange={handleChange}
          renderItem={renderItem}
          showFirstButton
          showLastButton
          size="small"
        />
      </Stack>
    </Box>
  );
};

export default Pagination;
